import CityPage from "../CityPage";

export default function Schaumburg() {
  return <CityPage slug="schaumburg" />;
}
